exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n#app {\n    height: 100%;\n}\n\n", ""]);
